<template>
  <div class="modal fade " ref="campaignStatusesModel" id="campaignStatusesModel">
    <div class="modal-dialog">
      <div class="modal-content" style="width: 1200px">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title w-100">{{ $t('orders.statuses') }}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div v-if="isLoader">
          <loader />
        </div>
        <div v-else class="modal-body">
          <div class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
              <div class="col-md-3 pr-0">
                <select v-if="component === 'leads'" ref="leadsStatuses" name="leadsStatuses" class="ml-1" @change="selectedChange($event.target.value)">
                  <option value="">{{ $t('orders.statuses') }}</option>
                  <option v-for="option in statuses"
                          :value="option.key">
                    {{ option.key }}
                  </option>
                </select>
                <select v-else  class="ml-1"  @change="selectedChange($event.target.value)">
                  <option value="">{{ $t('orders.statuses') }}</option>
                  <option v-for="option in statuses" v-if="option.statusGroup == tconfig.statusGroup"
                          :value="option.key">
                    {{ option.value }}
                  </option>
                </select>
              </div>

              <form v-if="component === 'leads'" @submit.prevent="sendLeadsData()" class=" mb-2">
                <button v-if="statusId && hideBtn" type="submit" class="btn btn-color-1">
                  {{ $t('orders.submit') }}
                </button>
                <p v-if="countOfResultStatus" class="text-success font-weight-bold">
                  <span>{{ countOfResultStatus }} </span><span>הודעות, נמצאים בסטטוס המתנה</span></p>
              </form>
              <form v-else @submit.prevent="sendData()" class=" mb-2">
                <button v-if="statusId && hideBtn" type="submit" class="btn btn-color-1">
                  {{ $t('orders.submit') }}
                </button>
                <p v-if="countOfResultStatus" class="text-success font-weight-bold">
                  <span>{{ countOfResultStatus }} </span><span>הודעות, נמצאים בסטטוס המתנה</span></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import Multiselect from "vue-multiselect";
import { updateStatusNew } from '@/utils/utilsFunctions.js';

import loader from '@/components/loader'

export default {

  components: {Multiselect,  loader},
  name: 'CampaignStatuses',
  props: {
    statuses: Array,
    previewOrderList: Array,
    model: String,
    tconfig: Object,
    routhName: String,
    component: String,

  },

  data() {

    return {
      statusId: '',
      hideBtn: false,
      countOfResultStatus: 0,
      isLoader: false,
    }

  },

  created() {

  },
  methods: {
    selectedChange(statusId) {
      if (!statusId) {
        console.log('something was wrong!')
        this.hideBtn = false;
        return;
      }
      this.hideBtn = true;
      this.statusId = statusId;

    },
    sendData() {


      if (!this.statusId) {
        console.log('missing statusId');
        return;
      }


      let that = this;
      if (confirm(`${this.previewOrderList.length} רשומות עומדים להישלח, האם להמשיך ? `)) {
        this.isLoader = true;
        //updateStatusNew(this.tconfig.options, this.tconfig.statusGroupName, params, '', this.previewOrderList)
        let configOptions = this.tconfig.options;
        let type = this.tconfig.statusGroupName;

        let params = {
          previewOrderList : this.previewOrderList,
          [type] : this.statusId,
          isCampaignStatusUpdate: true,
          orderStatus: this.statusId,
        }

        let data = {
          //[type]: parseInt(this.$refs[type].value)
          [type]: params ? parseInt(params.orderStatus) :parseInt(this.$refs[type].value)
        };



        let msgContent = '';

        // old value
        let comperar = '';
        let optionKey = '';
        let noteName = '';

        switch (type) {
          case 'orderStatus':
            comperar = 'statusId';
            optionKey = 'statuses';
            noteName = 'סטטוס הזמנה'
            break;
          case 'lackOfClaimsStatus':
            comperar = 'lackOfClaimsStatus';
            optionKey = 'lackOfClaims';
            noteName = 'עבר ביטוחי';
            break;
          case 'paymentStatus':
            comperar = 'paymentStatus';
            optionKey = 'paymentStatus';
            noteName = 'גביה'
            break;
          case 'changesStatus':
            comperar = 'changesStatus';
            optionKey = 'changesStatus';
            noteName = 'שינויים'
            break;
          case 'claimsStatus':
            comperar = 'claimsStatus';
            optionKey = 'claimsStatus';
            noteName = 'תביעות'
            break;
          case 'policyStatus':
            comperar = 'policyStatus';
            optionKey = 'policyStatus';
            noteName = 'ביטול'
            break;
          case 'protectiveStatus':
            comperar = 'protectiveStatus';
            optionKey = 'protectionStatus';
            noteName = 'מיגון';
            break;
         case 'renewalStatus':
          comperar = 'statusId';
          optionKey = 'renewalsStatus';
          noteName = 'חידושים';
          break;
        }


        //translate old value
        for (let i in configOptions[optionKey]) {
          if (configOptions[optionKey][i].key == params['previewOrderList'][0]['rowInfo'][comperar]) {
            msgContent += configOptions[optionKey][i].value
          }
        }
        //translate new value
        for (let i in configOptions[optionKey]) {
          if (configOptions[optionKey][i].key == params[type]) {
            msgContent += ' > ' + configOptions[optionKey][i].value
          }
        }



        let sendParamsInfo = {
          'subject' : noteName,
          'description': msgContent,
          'previewOrderList' : params['previewOrderList'],
          'routhName' : this.routhName,
          data

        }

        let autoMessage = {
          statusType: 'orderStatus',
          selectedStatusId : parseInt(params['orderStatus'])
        };


        let routeName = this.routhName === 'renewals' ? 'renewals' : 'orders';
        axios.post(`/orders/checkIfNeedToSendAutoMessage/${this.$route.query.id}`,  autoMessage)
          .then((res) => {
            data.isConfirmedToSend = false;
            if(res.data && res.data.data && res.data.data.res && res.data.data.res.isAutoMessage) {
              const name = res.data.data.res.name
              data.isConfirmedToSend = confirm(`שינוי הסטטוס ישלח ללקוח הודעה מסוג ${name} - האם לשלוח הודעה ? `)
            }
            // Now update the status
            //let rowId = baseInfo['rowInfo']['id'];

            //addNewNoteQuery(notInfo, rowId);

            let that = this;
            axios.post(`/${routeName}/updateMultipleStatus`, sendParamsInfo)
              .then((res) => {
                that.isLoader = false
                window.location.reload()
                //this.$emit('alert', 'success', 'Status updated')
                //this.appendData()
              }).catch((err) => {
              //this.$emit('alert', 'danger', err.response.data.data.error)
            })
        })




      } else {
        //this.hideBtn = false;
        this.closeModal();
      }
    },
    closeModal() {
      let element = this.$refs.campaignStatusesModel
      $(element).modal('hide')
    },
    sendLeadsData() {

      let sendParamsInfo = {
        'previewOrderList' : this.previewOrderList,
        'leadType':  this.statusId

      }

      let that = this;
      axios.post(`/leads/updateMultipleStatus`, sendParamsInfo)
        .then((res) => {
          that.isLoader = false
          window.location.reload()
          //this.$emit('alert', 'success', 'Status updated')
          //this.appendData()
        }).catch((err) => {
        //this.$emit('alert', 'danger', err.response.data.data.error)
      })
    }

  }
}

</script>


